import ContentHeader from 'components/elements/ContentHeader';
import React, { useState } from 'react';
import AuthenticityToken from 'shared/AuthenticityToken/AuthenticityToken';
import InventoryTable from './InventoryTable';
import useStores from 'utils/useStores';
import { observer } from 'mobx-react';
import MassChangesOverlay from './MassChangesOverlay';
import Pagynation from 'shared/Pagynation';
import Routes from 'routes';
import LoadingSpinner from 'shared/FileUploader/components/LoadingSpinner';

interface InventoryReconcilationProps {
  canGenerateReport: boolean;
  cooldownActive: boolean;
  nextAvailableAt: string | null;
  generateReportPath: string;
}

const InventoryReconcilation = ({
  canGenerateReport,
  cooldownActive,
  nextAvailableAt,
  generateReportPath,
}: InventoryReconcilationProps): JSX.Element => {
  const { inventoryReconciliationStore } = useStores();
  const { selectedInventories, pagy } = inventoryReconciliationStore;

  const [manyChangesOverlay, setManyChangesOverlay] = useState(false);
  const [reportSubmitting, setReportSubmitting] = useState(false);

  const cooldownTitle =
    cooldownActive && nextAvailableAt
      ? I18n.translate('inventory_reconciliations.generate_report.cooldown', {
          when: nextAvailableAt,
        })
      : undefined;

  return (
    <div className='content'>
      <AuthenticityToken />
      <ContentHeader title={I18n.translate('headlines.inventory_conciliation')}>
        {canGenerateReport && (
          <form
            action={generateReportPath}
            method='post'
            style={{ display: 'inline', marginRight: '8px' }}
            onSubmit={() => setReportSubmitting(true)}
          >
            <AuthenticityToken />
            <button
              type='submit'
              disabled={cooldownActive || reportSubmitting}
              title={cooldownTitle}
              className='button button--blue'
            >
              {reportSubmitting ? (
                <>
                  <LoadingSpinner size={14} />{' '}
                  {I18n.translate(
                    'inventory_reconciliations.generate_report.in_progress'
                  )}
                </>
              ) : (
                I18n.translate('inventory_reconciliations.generate_report.button')
              )}
            </button>
          </form>
        )}
        <button
          type='button'
          disabled={selectedInventories.length === 0}
          className='button button--green'
          onClick={() => setManyChangesOverlay(true)}
        >
          {I18n.translate('buttons.concile')}
        </button>
      </ContentHeader>
      <InventoryTable />
      <Pagynation pagy={pagy} url={Routes.inventory_reconciliations_path} />
      {manyChangesOverlay && (
        <MassChangesOverlay setManyChangesOverlay={setManyChangesOverlay} />
      )}
    </div>
  );
};

export default observer(InventoryReconcilation);
